import React from 'react';

/**
 * 🛡️ XAVFSIZLIK — loyihaning jonli manzillarini Security Khorezmai skaneriga beradi.
 *
 * Skan dvigateli ALOHIDA jarayon (o'z bazasi bilan), lekin u endi ICHKI — o'z
 * domeni, UI'si va login'i YO'Q (2026-09-08). Operator uchun yagona eshik shu panel:
 * nishonlar, skan, topilmalar va tuzatish qadamlari — hammasi Khorezmai ichida.
 *
 * 🔴 RUXSAT (authorized) — huquqiy qo'riqchi: ruxsatsiz skan noqonuniy. Shuning
 * uchun nishon DOIM ruxsatsiz qo'shiladi, operator uni ATAYLAB yoqadi.
 *
 * `authFetch` har render'da yangi identity — effekt dep'iga QO'YILMAYDI (refetch-storm).
 */

// Davriy avto-skan oralig'i. Security cron'i har 15 daqiqada "vaqti keldimi" deb qaraydi.
const STEP_CLS = { PROPOSED: 'bg-gray-200 dark:bg-gray-600 text-gray-700 dark:text-gray-300', APPROVED: 'bg-emerald-100 dark:bg-emerald-900/50 text-emerald-700 dark:text-emerald-400',
  REJECTED: 'bg-gray-200 dark:bg-gray-600 text-gray-500 dark:text-gray-400', RUNNING: 'bg-blue-100 dark:bg-blue-900/50 text-blue-700 dark:text-blue-400',
  DONE: 'bg-green-100 dark:bg-green-900/50 text-green-700 dark:text-green-400', FAILED: 'bg-red-100 dark:bg-red-900/50 text-red-700 dark:text-red-400', ROLLED_BACK: 'bg-amber-100 dark:bg-amber-900/50 text-amber-700 dark:text-amber-400' };
const STEP_LBL = { PROPOSED: 'taklif', APPROVED: 'tasdiqlangan', REJECTED: 'rad etilgan', RUNNING: 'bajarilmoqda',
  DONE: 'bajarildi', FAILED: 'xato', ROLLED_BACK: 'qaytarildi' };
const RISK_CLS = { LOW: 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400', MEDIUM: 'bg-amber-100 dark:bg-amber-900/50 text-amber-700 dark:text-amber-400',
  HIGH: 'bg-orange-100 dark:bg-orange-900/50 text-orange-700 dark:text-orange-400', CRITICAL: 'bg-red-100 dark:bg-red-900/50 text-red-700 dark:text-red-400' };
// ── 🔍 Topilmalar ko'rinishi ────────────────────────────────────────────────
// Ilgari tafsilotni ko'rish uchun ALOHIDA Security ilovasiga kirish kerak edi.
const F_STATUS = {
  FAIL: { c: 'bg-red-100 dark:bg-red-900/50 text-red-700 dark:text-red-400', t: 'yiqildi' },
  WARN: { c: 'bg-amber-100 dark:bg-amber-900/50 text-amber-700 dark:text-amber-400', t: 'ogohlantirish' },
  UNVERIFIED: { c: 'bg-sky-100 dark:bg-sky-900/50 text-sky-700 dark:text-sky-400', t: 'tasdiqlanmadi' },
  ERROR: { c: 'bg-gray-200 dark:bg-gray-600 text-gray-600 dark:text-gray-400', t: 'xato' },
  PASS: { c: 'bg-emerald-100 dark:bg-emerald-900/50 text-emerald-700 dark:text-emerald-400', t: 'joyida' },
  INFO: { c: 'bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400', t: 'maʼlumot' },
};
const F_SEV = {
  CRITICAL: 'bg-red-600 text-white', HIGH: 'bg-orange-100 dark:bg-orange-900/50 text-orange-700 dark:text-orange-400',
  MEDIUM: 'bg-amber-100 dark:bg-amber-900/50 text-amber-700 dark:text-amber-400', LOW: 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400',
  INFO: 'bg-gray-100 dark:bg-gray-700 text-gray-400',
};
// Muammoli holatlar — standart filtr shular (PASS/INFO shovqinini yashiradi:
// bitta auditda 98 topilmadan 76 tasi PASS/INFO bo'ladi).
const F_PROBLEM = ['FAIL', 'WARN', 'UNVERIFIED', 'ERROR'];
const F_ORDER = { FAIL: 0, WARN: 1, UNVERIFIED: 2, ERROR: 3, INFO: 4, PASS: 5 };

function FindingsView({ data }) {
  const [onlyProblems, setOnlyProblems] = React.useState(true);
  const [open, setOpen] = React.useState(null);
  if (!data) return <div className="text-xs text-gray-400 mt-2">Yuklanmoqda…</div>;

  const all = data.findings || [];
  const list = (onlyProblems ? all.filter(f => F_PROBLEM.includes(f.status)) : all)
    .slice().sort((a, b) => (F_ORDER[a.status] ?? 9) - (F_ORDER[b.status] ?? 9));
  const counts = data.counts || {};
  const cov = data.coverage || {};
  // «Qaysi vosita ishlamadi» — buni KO'RSATMASAK yarim skan to'liq skandek ko'rinadi.
  const gaps = Array.isArray(cov.missing) ? cov.missing : [];

  return (
    <div className="mt-2">
      <div className="flex items-center gap-2 flex-wrap mb-2">
        {Object.keys(counts).sort((a, b) => (F_ORDER[a] ?? 9) - (F_ORDER[b] ?? 9)).map(k => (
          <span key={k} className={`px-2 py-0.5 rounded text-[11px] font-medium ${(F_STATUS[k] || {}).c || 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400'}`}>
            {(F_STATUS[k] || {}).t || k}: {counts[k]}
          </span>
        ))}
        {typeof data.scan?.score === 'number' && (
          <span className="px-2 py-0.5 rounded text-[11px] font-semibold bg-primary-100 dark:bg-primary-900/50 text-primary-800 dark:text-primary-300">ball {data.scan.score}/100</span>
        )}
        <label className="flex items-center gap-1 text-[11px] text-gray-600 dark:text-gray-400 ml-auto">
          <input type="checkbox" className="w-3.5 h-3.5 accent-primary-700"
            checked={onlyProblems} onChange={() => setOnlyProblems(v => !v)} />
          faqat muammolar
        </label>
      </div>

      {gaps.length > 0 && (
        <div className="rounded-lg bg-amber-50 dark:bg-amber-900/30 border border-amber-200 dark:border-amber-800 p-2.5 mb-2">
          <div className="text-[11px] font-semibold text-amber-800 dark:text-amber-300">⚠️ Qamrov boʻshligʻi — bu skan hamma narsani koʻrmadi:</div>
          <ul className="text-[11px] text-amber-800 dark:text-amber-300 mt-1 list-disc list-inside space-y-0.5">
            {gaps.map((g, i) => <li key={i}>{g}</li>)}
          </ul>
        </div>
      )}
      {data.scan?.summary && (
        <p className="text-[11px] text-gray-600 dark:text-gray-400 mb-2 whitespace-pre-wrap">{data.scan.summary}</p>
      )}

      {!list.length && <div className="text-xs text-gray-400">Bu filtrda topilma yoʻq.</div>}
      <div className="space-y-1.5">
        {list.map(f => {
          const st = F_STATUS[f.status] || { c: 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400', t: f.status };
          const isOpen = open === f.id;
          return (
            <div key={f.id} className="rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800">
              <button onClick={() => setOpen(isOpen ? null : f.id)}
                className="w-full text-left p-2.5 flex items-start gap-2 flex-wrap hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg">
                <span className={`px-1.5 py-0.5 rounded text-[10px] font-semibold ${st.c}`}>{st.t}</span>
                <span className={`px-1.5 py-0.5 rounded text-[10px] font-semibold ${F_SEV[f.severity] || 'bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400'}`}>{String(f.severity || '').toLowerCase()}</span>
                <span className="px-1.5 py-0.5 rounded text-[10px] bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400">{f.source}</span>
                {f.owasp && <span className="px-1.5 py-0.5 rounded text-[10px] bg-primary-50 dark:bg-primary-900/30 text-primary-800 dark:text-primary-300">{f.owasp}</span>}
                {f.cwe && <span className="px-1.5 py-0.5 rounded text-[10px] bg-primary-50 dark:bg-primary-900/30 text-primary-800 dark:text-primary-300">{f.cwe}</span>}
                <span className="text-xs font-medium text-gray-900 dark:text-white flex-1 min-w-[12rem]">{f.title}</span>
                <span className="text-[10px] text-gray-400">{isOpen ? '▲' : '▼'}</span>
              </button>
              {isOpen && (
                <div className="px-2.5 pb-2.5 space-y-1.5">
                  {f.url && <div className="text-[11px] text-gray-600 dark:text-gray-400 break-all">🔗 {f.method ? f.method + ' ' : ''}{f.url}{f.param ? ` · parametr: ${f.param}` : ''}</div>}
                  {f.attack && <div className="text-[11px] text-gray-500 dark:text-gray-400">🎯 hujum: {f.attack}</div>}
                  {f.why && <div className="text-[11px] text-gray-700 dark:text-gray-300"><b>Nima muammo:</b> {f.why}</div>}
                  {f.fix && <div className="text-[11px] text-emerald-800 dark:text-emerald-300 bg-emerald-50 dark:bg-emerald-900/30 rounded p-2"><b>Qanday tuzatiladi:</b> {f.fix}</div>}
                  {f.raw && <pre className="text-[10px] bg-gray-900 text-gray-100 rounded p-2 max-h-48 overflow-auto whitespace-pre-wrap break-all">{f.raw}</pre>}
                  {f.request && <pre className="text-[10px] bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-700 rounded p-2 max-h-40 overflow-auto whitespace-pre-wrap break-all">{f.request}</pre>}
                  {Array.isArray(f.refs) && f.refs.length > 0 && (
                    <div className="text-[10px] text-gray-500 dark:text-gray-400 break-all">
                      {f.refs.map((r, i) => <a key={i} href={r} target="_blank" rel="noreferrer" className="text-primary-700 dark:text-primary-500 hover:underline mr-2">manba{i + 1}</a>)}
                    </div>
                  )}
                  {f.confidence && <div className="text-[10px] text-gray-400">ishonch: {f.confidence}</div>}
                </div>
              )}
            </div>
          );
        })}
      </div>
      {data.truncated && <p className="text-[11px] text-gray-400 mt-2">Faqat birinchi {list.length} ta koʻrsatildi (jami {data.total}).</p>}
    </div>
  );
}

const INTERVALS = [
  { h: 24, t: 'kunlik' }, { h: 72, t: '3 kunda' }, { h: 168, t: 'haftalik' }, { h: 720, t: 'oylik' },
];

const SCAN_LBL = {
  QUEUED: 'navbatda', RUNNING: 'ketmoqda', COMPLETED: 'tugadi',
  FAILED: 'xato', CANCELLED: 'bekor',
};
const SCAN_CLS = {
  QUEUED: 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400', RUNNING: 'bg-amber-100 dark:bg-amber-900/50 text-amber-700 dark:text-amber-400 animate-pulse',
  COMPLETED: 'bg-emerald-100 dark:bg-emerald-900/50 text-emerald-700 dark:text-emerald-400', FAILED: 'bg-red-100 dark:bg-red-900/50 text-red-700 dark:text-red-400',
  CANCELLED: 'bg-gray-100 dark:bg-gray-700 text-gray-400',
};

function fmtDate(s) {
  if (!s) return '';
  const d = new Date(s);
  if (isNaN(d)) return '';
  const p = (n) => String(n).padStart(2, '0');
  return `${p(d.getDate())}.${p(d.getMonth() + 1)} ${p(d.getHours())}:${p(d.getMinutes())}`;
}

// ── 📊 Dashboard yordamchilari (Flowbite admin-dashboard uslubi) ────────────
// Karta = `bg-white border border-gray-200 rounded-lg shadow-sm`, katta raqam +
// izoh + mini-ustunlar. Har server O'Z kartasida: ball, manzillar, tuzatish.

const scoreTone = (n) => (typeof n !== 'number' ? 'none' : n >= 80 ? 'good' : n >= 50 ? 'mid' : 'bad');
const SCORE_TXT = {
  good: 'text-emerald-600 dark:text-emerald-400', mid: 'text-amber-600 dark:text-amber-400',
  bad: 'text-red-600 dark:text-red-400', none: 'text-gray-400',
};
const SCORE_BAR = { good: 'bg-emerald-500', mid: 'bg-amber-500', bad: 'bg-red-500', none: 'bg-gray-300 dark:bg-gray-600' };
const LIVE = ['QUEUED', 'RUNNING', 'ANALYZING'];
const isLive = (st) => LIVE.includes(String(st || '').toUpperCase());

/** Katta ko'rsatkich kartasi (Flowbite "stats" kartasi). */
function StatCard({ icon, label, value, sub, tone = 'none', right, onClick, title }) {
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag onClick={onClick} title={title}
      className={`text-left bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-sm p-4 sm:p-5 flex items-start justify-between gap-3 ${onClick ? 'hover:bg-gray-50 dark:hover:bg-gray-700/60 transition' : ''}`}>
      <div className="min-w-0">
        <div className="text-xs font-medium text-gray-500 dark:text-gray-400 flex items-center gap-1.5"><span>{icon}</span>{label}</div>
        <div className={`mt-1 text-2xl sm:text-3xl font-bold leading-none ${tone && tone !== 'none' ? SCORE_TXT[tone] : 'text-gray-900 dark:text-white'}`}>{value}</div>
        {sub && <div className="mt-1.5 text-xs text-gray-500 dark:text-gray-400 leading-snug">{sub}</div>}
      </div>
      {right}
    </Tag>
  );
}

/** Ball tarixi — mini ustunlar (eskidan yangiga). Ketayotgan skan pulsatsiya qiladi. */
function MiniBars({ items = [], height = 40 }) {
  const list = items.slice().reverse();  // history = yangi → eski; chizmada chapdan o'ngga vaqt
  if (!list.length) return null;
  return (
    <div className="flex items-end gap-1" style={{ height }} title="Oxirgi auditlar bali (chapdan o'ngga — eskidan yangiga)">
      {list.map((h, i) => {
        const sc = typeof h.postureScore === 'number' ? h.postureScore : (typeof h.score === 'number' ? h.score : null);
        const live = isLive(h.status);
        const pct = live ? 35 : sc === null ? 10 : Math.max(6, sc);
        return (
          <div key={h.id || i} className={`flex-1 rounded-sm ${live ? 'bg-primary-300 dark:bg-primary-700 animate-pulse' : SCORE_BAR[scoreTone(sc)]} ${i === list.length - 1 ? '' : 'opacity-60'}`}
            style={{ height: `${pct}%` }} title={`${fmtDate(h.createdAt)} · ${live ? 'ketmoqda' : sc === null ? 'ballsiz' : sc + '/100'}`} />
        );
      })}
    </div>
  );
}

/** Jonli progress (skan ketayotganda). */
function LiveProgress({ p }) {
  if (!p || typeof p.total !== 'number' || !p.total) return null;
  const pct = Math.min(100, Math.round((Number(p.done || 0) / p.total) * 100));
  return (
    <div className="mt-2">
      <div className="flex justify-between text-[11px] text-gray-500 dark:text-gray-400 mb-0.5">
        <span className="truncate">{p.label || p.phase || 'ketmoqda…'}</span><span>{p.done}/{p.total}</span>
      </div>
      <div className="w-full h-1.5 rounded-full bg-gray-200 dark:bg-gray-600 overflow-hidden">
        <div className="h-1.5 rounded-full bg-primary-600 transition-all" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}

/** Oldingi skanga nisbatan farq chiplari. */
function DiffChips({ d }) {
  if (!d) return null;
  const parts = [
    d.new ? { k: 'new', t: `🆕 ${d.new} yangi`, c: 'bg-amber-100 dark:bg-amber-900/50 text-amber-800 dark:text-amber-300' } : null,
    d.regressed ? { k: 'reg', t: `🔴 ${d.regressed} qaytdi`, c: 'bg-red-100 dark:bg-red-900/50 text-red-700 dark:text-red-400' } : null,
    d.fixed ? { k: 'fix', t: `✅ ${d.fixed} tuzatildi`, c: 'bg-emerald-100 dark:bg-emerald-900/50 text-emerald-700 dark:text-emerald-400' } : null,
    typeof d.stillOpen === 'number' ? { k: 'open', t: `⏳ ${d.stillOpen} ochiq`, c: 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400' } : null,
  ].filter(Boolean);
  if (!parts.length) return null;
  return (
    <div className="flex flex-wrap gap-1 mt-2" title="Oldingi auditga nisbatan">
      {parts.map(p => <span key={p.k} className={`px-1.5 py-0.5 rounded text-[10px] font-medium ${p.c}`}>{p.t}</span>)}
    </div>
  );
}

/** Kartaning ichki bo'limi (sarlavha + tana). */
function Tile({ title, right, children, className = '' }) {
  return (
    <div className={`rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50/60 dark:bg-gray-900/30 p-3 ${className}`}>
      <div className="flex items-center justify-between gap-2 mb-2">
        <div className="text-xs font-semibold text-gray-700 dark:text-gray-300">{title}</div>
        {right}
      </div>
      {children}
    </div>
  );
}

export default function SecurityPanel({ authFetch, apiUrl, projectId }) {
  const [status, setStatus] = React.useState(null);
  const [data, setData] = React.useState(null);
  const [scans, setScans] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [err, setErr] = React.useState('');
  const [picked, setPicked] = React.useState([]);      // sirt kalitlari
  const [busy, setBusy] = React.useState('');
  const [findings, setFindings] = React.useState(null);   // {total, new}
  const [servers, setServers] = React.useState(null);    // 🖥 SSH audit nishonlari
  const [stepsFor, setStepsFor] = React.useState(null);  // qaysi skan rejasi ochiq
  const [steps, setSteps] = React.useState(null);        // {steps:[...]} yoki null=yuklanmoqda
  const [fixRisk, setFixRisk] = React.useState('LOW');   // ommaviy tuzatish darajasi
  const [fixJob, setFixJob] = React.useState(null);      // ketayotgan ommaviy tuzatish
  const [findFor, setFindFor] = React.useState(null);    // 'server:<id>' | 'web:<id>'
  const [findData, setFindData] = React.useState(null);  // topilmalar tafsiloti
  const [stepInfo, setStepInfo] = React.useState({});    // ℹ️ qadam izohi: {stepId: {loading, text, open, error}}
  const [toast, setToast] = React.useState('');
  const afRef = React.useRef(authFetch);
  afRef.current = authFetch;

  const say = (m) => { setToast(m); setTimeout(() => setToast(''), 4000); };

  const load = React.useCallback(async (quiet = false) => {
    if (!projectId) return;
    if (!quiet) setLoading(true);
    try {
      const [sr, or] = await Promise.all([
        afRef.current(`${apiUrl}/security/status`),
        afRef.current(`${apiUrl}/security/overview?projectId=${projectId}`),
      ]);
      const sj = await sr.json().catch(() => ({}));
      const oj = await or.json().catch(() => ({}));
      if (sr.ok) setStatus(sj);
      if (or.ok) { setData(oj); setErr(''); }
      else setErr(oj.error || 'Ma`lumot olinmadi');
      if (or.ok && oj.configured) {
        const cr = await afRef.current(`${apiUrl}/security/scans?projectId=${projectId}`);
        const cj = await cr.json().catch(() => ({}));
        if (cr.ok && Array.isArray(cj.scans)) setScans(cj.scans);
        // 🖥 Server (SSH) auditi — web skanidan ALOHIDA: ichkariga kirib tizimni tekshiradi.
        const sr2 = await afRef.current(`${apiUrl}/security/servers?projectId=${projectId}`);
        const sj2 = await sr2.json().catch(() => ({}));
        if (sr2.ok && Array.isArray(sj2.servers)) setServers(sj2.servers);
        // 🐞 Topilmalar — skaner topganlari shu loyihaning umumiy topilmalar oqimida.
        const fr = await afRef.current(`${apiUrl}/agent-findings?projectId=${projectId}`);
        const fj = await fr.json().catch(() => ({}));
        if (fr.ok && Array.isArray(fj.findings)) {
          const sec = fj.findings.filter(x => x.source === 'security');
          setFindings({ total: sec.length, new: sec.filter(x => x.status === 'new').length,
                        high: sec.filter(x => x.severity === 'high' && x.status === 'new').length });
        }
      }
    } catch (e) { setErr(String(e.message || e)); }
    finally { setLoading(false); }
  }, [apiUrl, projectId]);

  React.useEffect(() => { setPicked([]); load(); }, [load]);
  // Skan ketayotgan bo'lsa jonli yangilanadi
  React.useEffect(() => {
    if (!scans.some(s => s.status === 'RUNNING' || s.status === 'QUEUED')) return;
    const t = setInterval(() => load(true), 12000);
    return () => clearInterval(t);
  }, [scans, load]);

  const surfaces = (data && data.surfaces) || [];
  const newOnes = surfaces.filter(s => !s.target);
  const toggle = (k) => setPicked(p => p.includes(k) ? p.filter(x => x !== k) : [...p, k]);

  async function addTargets() {
    if (!picked.length) return;
    setBusy('sync');
    try {
      const r = await afRef.current(`${apiUrl}/security/sync`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ projectId, surfaces: picked }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) { say('❌ ' + (j.error || 'Qo`shilmadi')); return; }
      say(`✅ ${j.created.length} ta nishon qo'shildi${j.failed && j.failed.length ? ` · ${j.failed.length} xato` : ''}`);
      setPicked([]); load(true);
    } catch (e) { say('❌ ' + e.message); } finally { setBusy(''); }
  }

  async function setFlag(target, patch) {
    setBusy(target.id);
    try {
      const r = await afRef.current(`${apiUrl}/security/targets/${target.id}`, {
        method: 'PATCH', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ projectId, ...patch }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) say('❌ ' + (j.error || 'O`zgarmadi')); else load(true);
    } catch (e) { say('❌ ' + e.message); } finally { setBusy(''); }
  }

  async function enableServer(srv) {
    if (!window.confirm(
      `«${srv.host}» serverini SSH auditiga ulaymizmi?\n\n` +
      `Xavfsizlik skaneri shu serverga ${srv.username} sifatida SSH bilan kirib tizimni tekshiradi ` +
      `(firewall, portlar, SSH sozlamalari, Docker, sirlar, loglar).\n\n` +
      `Buning uchun Khorezmai'ning DEPLOY KALITI skanerga beriladi — u shifrlangan holda saqlanadi. ` +
      `Kalit allaqachon shu serverga ruxsatli (prod deploy shu bilan ketadi).`)) return;
    setBusy('srv:' + srv.host);
    try {
      const r = await afRef.current(`${apiUrl}/security/servers/enable`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ projectId, host: srv.host }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) say('❌ ' + (j.error || 'Ulanmadi'));
      else {
        const okConn = j.connection && (j.connection.ok === true || j.connection.success === true);
        say(okConn ? '✅ Server ulandi va SSH tekshirildi — endi ▶ Audit qilsangiz bo`ladi'
                   : '⚠️ Server qo`shildi, lekin SSH ulanishi tasdiqlanmadi — kalit ruxsatini tekshiring');
        load(true);
      }
    } catch (e) { say('❌ ' + e.message); } finally { setBusy(''); }
  }

  // mode: 'AUDIT' (faqat o'qiydi) yoki 'REMEDIATION' (qo'shimcha AI tuzatish REJASI —
  // qadamlar taklif bo'lib turadi, HECH NARSA bajarilmaydi; bajarishni operator bosadi).
  async function serverAudit(srv, mode = 'AUDIT') {
    setBusy('srv:' + srv.host);
    try {
      const r = await afRef.current(`${apiUrl}/security/server-scan`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ projectId, targetId: srv.target.id, mode }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) say('❌ ' + (j.error || 'Audit boshlanmadi'));
      else {
        say(mode === 'REMEDIATION'
          ? '🔧 Tuzatish rejasi tayyorlanmoqda — audit + AI reja, bir necha daqiqa oladi'
          : '🖥 SSH auditi boshlandi — bir necha daqiqa oladi');
        load(true);
      }
    } catch (e) { say('❌ ' + e.message); } finally { setBusy(''); }
  }

  // ── 🔧 Tuzatish qadamlari ────────────────────────────────────────────────
  async function loadSteps(scanId) {
    setStepsFor(scanId); setSteps(null);
    try {
      const r = await afRef.current(`${apiUrl}/security/server-scan/${scanId}?projectId=${projectId}`);
      const j = await r.json().catch(() => ({}));
      if (!r.ok) { say('❌ ' + (j.error || 'Reja o`qilmadi')); setStepsFor(null); return; }
      setSteps(j);
    } catch (e) { say('❌ ' + e.message); setStepsFor(null); }
  }

  // ── ℹ️ Ma'lumot — «bu zaiflikni SHU loyiha uchun nega yopish kerak?» ─────
  // Backend qadamni o'z topilmasi + loyiha konteksti bilan AI'ga beradi; natija
  // serverda keshlanadi (bir qadam = bir marta), shuning uchun qayta bosish bepul.
  async function explainStep(scanId, st, refresh = false) {
    const cur = stepInfo[st.id];
    if (cur && cur.text && !refresh) {
      setStepInfo(m => ({ ...m, [st.id]: { ...cur, open: !cur.open } }));
      return;
    }
    setStepInfo(m => ({ ...m, [st.id]: { loading: true, open: true, text: cur && cur.text, error: '' } }));
    try {
      const r = await afRef.current(`${apiUrl}/security/steps/${scanId}/${st.id}/explain?projectId=${projectId}${refresh ? '&refresh=1' : ''}`);
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.error || 'Izoh olinmadi');
      setStepInfo(m => ({ ...m, [st.id]: { loading: false, open: true, text: j.text, cached: !!j.cached, error: '' } }));
    } catch (e) {
      setStepInfo(m => ({ ...m, [st.id]: { loading: false, open: true, text: cur && cur.text, error: e.message } }));
    }
  }

  // ── 🔍 Skan topilmalari (server auditi yoki web-skan) ────────────────────
  async function loadFindings(kind, scanId) {
    const key = `${kind}:${scanId}`;
    if (findFor === key) { setFindFor(null); setFindData(null); return; }
    setFindFor(key); setFindData(null);
    try {
      const r = await afRef.current(`${apiUrl}/security/findings/${kind}/${scanId}?projectId=${projectId}`);
      const j = await r.json().catch(() => ({}));
      if (!r.ok) { say('❌ ' + (j.error || 'Topilmalar oʻqilmadi')); setFindFor(null); return; }
      setFindData(j);
    } catch (e) { say('❌ ' + e.message); setFindFor(null); }
  }

  async function stepAction(scanId, step, action) {
    // 🔴 «execute» serverni HAQIQATAN o'zgartiradi — shuning uchun buyruqni ko'rsatib
    // tasdiqlatamiz. Hech qachon avtomatik chaqirilmaydi.
    if (action === 'execute' && !window.confirm(
      `Serverda BAJARILADI:\n\n${step.command}\n\n` +
      (step.backupCmd ? `Avval zaxira olinadi:\n${step.backupCmd}\n\n` : 'Zaxira buyrug`i yo`q!\n\n') +
      'Davom etamizmi?')) return;
    if (action === 'rollback' && !window.confirm(`Orqaga qaytariladi:\n\n${step.rollbackCmd || '—'}\n\nDavom etamizmi?`)) return;
    await runStep(scanId, step, action, false);
  }

  /**
   * 🛡️ Qorovul javobini o'qish. Backend bajarilgandan KEYIN ishni tekshiradi va
   * buzilgan bo'lsa O'ZI orqaga qaytaradi — bu yerda o'sha natijani ko'rsatamiz.
   */
  async function runStep(scanId, step, action, force) {
    setBusy('step:' + step.id);
    try {
      const r = await afRef.current(`${apiUrl}/security/steps/${scanId}/${step.id}/${action}`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ projectId, ...(force ? { force: true } : {}) }),
      });
      const j = await r.json().catch(() => ({}));

      // Xavfli qadam, lekin himoya qo'yib bo'lmadi — ATAYIN so'raymiz.
      if (!r.ok && j.code === 'GUARD_NO_DEADMAN') {
        if (window.confirm(
          (j.error || '') + '\n\nBaribir bajarilsinmi?\n\n' +
          'Diqqat: bu qadam tarmoq/kirish qatlamiga tegadi. Xato bo\'lsa serverga ' +
          'qayta kira olmasligingiz mumkin va avtomatik qaytarish ISHLAMAYDI.')) {
          setBusy(''); return runStep(scanId, step, action, true);
        }
        say('⏹ Bekor qilindi');
      } else if (r.status === 409 && j.code === 'GUARD_ROLLBACK') {
        // Qorovul ushladi.
        window.alert('🛡️ QOROVUL\n\n' + (j.error || '') +
          ((j.guard && j.guard.broken || []).length ? '\n\nBuzilgani: ' + j.guard.broken.join(', ') : ''));
        say(j.guard && j.guard.rolledBack ? '🛡️ Buzildi — orqaga qaytarildi' : '🛡️ Buzildi — DIQQAT');
      } else if (!r.ok) {
        say('❌ ' + (j.error || 'Amal bajarilmadi'));
      } else if (action === 'execute') {
        say(j.guard && j.guard.checked ? '✅ Bajarildi — tekshirildi, hammasi joyida' : '✅ Qadam bajarildi');
      } else {
        say(action === 'approve' ? '✅ Tasdiqlandi' : action === 'reject' ? '⏭ Rad etildi' : '↩ Orqaga qaytarildi');
      }
      await loadSteps(scanId);
    } catch (e) { say('❌ ' + e.message); } finally { setBusy(''); }
  }

  // ── 🚀 Ommaviy tuzatish ──────────────────────────────────────────────────
  const RISK_LBL = { LOW: 'past', MEDIUM: "o'rta", HIGH: 'yuqori' };
  const RANK = { LOW: 1, MEDIUM: 2, HIGH: 3 };

  async function startFix(scanId, stepsList) {
    const n = (stepsList || []).filter(x =>
      ['PROPOSED', 'APPROVED'].includes(String(x.status).toUpperCase()) &&
      (RANK[String(x.risk).toUpperCase()] || 3) <= (RANK[fixRisk] || 1)).length;
    if (!n) { say('Bu darajada bajarilmagan qadam yoʻq'); return; }
    const names = (stepsList || []).filter(x =>
      ['PROPOSED', 'APPROVED'].includes(String(x.status).toUpperCase()) &&
      (RANK[String(x.risk).toUpperCase()] || 3) <= (RANK[fixRisk] || 1))
      .slice(0, 8).map(x => `• [${RISK_LBL[String(x.risk).toUpperCase()] || '?'}] ${x.title}`).join('\n');
    if (!window.confirm(
      `${n} ta qadam SERVERDA bajariladi:\n\n${names}${n > 8 ? '\n• …' : ''}\n\n` +
      `Har qadamdan keyin ish tekshiriladi (SSH, saytlar, pm2, deploy huquqi). ` +
      `Biror narsa buzilsa — oʻsha qadam orqaga qaytariladi va jarayon TOʻXTAYDI.\n\nDavom etamizmi?`)) return;

    setBusy('fix'); setFixJob(null);
    try {
      const r = await afRef.current(`${apiUrl}/security/fix/${scanId}`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ projectId, maxRisk: fixRisk, ...(fixRisk === 'HIGH' ? { confirmHigh: true } : {}) }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) { say('❌ ' + (j.error || 'Boshlanmadi')); return; }
      setFixJob({ ...j.job, scanId });
      say('🚀 Tuzatish boshlandi');
    } catch (e) { say('❌ ' + e.message); } finally { setBusy(''); }
  }

  // Ketayotgan tuzatish holatini kuzatamiz (socket emas — oddiy poll yetarli).
  React.useEffect(() => {
    if (!fixJob || !fixJob.running || !fixJob.scanId) return;
    const id = setTimeout(async () => {
      try {
        const r = await afRef.current(`${apiUrl}/security/fix/${fixJob.scanId}?projectId=${projectId}`);
        const j = await r.json().catch(() => ({}));
        if (j && j.job) {
          setFixJob({ ...j.job, scanId: fixJob.scanId });
          if (!j.job.running) {
            say(j.job.stopped ? '🛡️ Toʻxtatildi — pastda sabab' : `✅ ${j.job.ok} ta qadam bajarildi`);
            loadSteps(fixJob.scanId);
          }
        }
      } catch { /* keyingi tikda */ }
    }, 4000);
    return () => clearTimeout(id);
  }, [fixJob, apiUrl, projectId]);   // eslint-disable-line react-hooks/exhaustive-deps

  async function setServerFlag(srv, patch) {
    setBusy('srv:' + srv.host);
    try {
      const r = await afRef.current(`${apiUrl}/security/servers/${srv.target.id}`, {
        method: 'PATCH', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ projectId, ...patch }),
      });
      if (!r.ok) { const j = await r.json().catch(() => ({})); say('❌ ' + (j.error || 'O`zgarmadi')); }
      else load(true);
    } catch (e) { say('❌ ' + e.message); } finally { setBusy(''); }
  }

  async function importFindings() {
    setBusy('import');
    try {
      const r = await afRef.current(`${apiUrl}/security/import-findings`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ projectId }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) say('❌ ' + (j.error || 'Ko`chirilmadi'));
      else say(j.imported || j.deduped
        ? `🐞 ${j.imported} ta yangi topilma qo'shildi${j.deduped ? `, ${j.deduped} tasi allaqachon bor edi` : ''}`
        : 'Yangi topilma yo`q — tugagan skan bo`lmasa avval ▶ Skan qiling');
      load(true);
    } catch (e) { say('❌ ' + e.message); } finally { setBusy(''); }
  }

  async function startScan(target, mode) {
    setBusy(target.id);
    try {
      const r = await afRef.current(`${apiUrl}/security/scan`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ projectId, targetId: target.id, mode }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) say('❌ ' + (j.error || 'Skan boshlanmadi'));
      else { say('🛡️ Skan boshlandi — tugagach «📋 Natija» da koʻrinadi'); load(true); }
    } catch (e) { say('❌ ' + e.message); } finally { setBusy(''); }
  }

  if (!projectId) return <div className="p-6 text-gray-500 dark:text-gray-400">Avval loyiha tanlang.</div>;

  if (status && status.configured === false) return (
    <div className="p-6">
      <div className="max-w-xl rounded-lg border border-amber-200 dark:border-amber-800 bg-amber-50 dark:bg-amber-900/30 p-5">
        <div className="font-semibold text-amber-800 dark:text-amber-300 mb-1">🛡️ Xavfsizlik skaneri ulanmagan</div>
        <div className="text-sm text-amber-700 dark:text-amber-400">
          Security Khorezmai bilan bog'lanish sozlanmagan. Administrator sozlamalarda
          <code className="mx-1 px-1 bg-white dark:bg-gray-800 rounded">security_api_url</code>,
          <code className="mx-1 px-1 bg-white dark:bg-gray-800 rounded">security_user</code> va parolni ko'rsatishi kerak.
        </div>
      </div>
    </div>
  );

  // ── 📊 Dashboard ma'lumotlari ──────────────────────────────────────────────
  // Har SERVER o'z kartasida: unga tegishli modullar, o'sha modullarning PROD
  // manzillari (web skan), SSH auditi bali/tarixi, topilmalar va tuzatish rejasi.
  // Test-muhit manzillari Khorezmai serverida yashaydi → alohida karta.
  const srvList = servers || [];
  const scansOfTarget = (t) => t ? scans
    .filter(x => (x.webTargetId || (x.webTarget && x.webTarget.id)) === t.id)
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) : [];
  const webScanOf = (t) => scansOfTarget(t)[0];
  const surfacesOf = (srv) => surfaces.filter(s => s.kind === 'prod' && (srv.modules || []).includes(s.moduleName));
  const assignedKeys = new Set(srvList.flatMap(srv => surfacesOf(srv).map(s => s.key)));
  const testSurfaces = surfaces.filter(s => s.kind === 'test');
  const otherSurfaces = surfaces.filter(s => s.kind === 'prod' && !assignedKeys.has(s.key));

  // Umumiy ball — eng PAST (zaif bo'g'in) + o'rtacha. Faqat tugagan skanlar.
  const allScores = [];
  srvList.forEach(srv => {
    const ls = srv.lastScan;
    if (ls && String(ls.status).toUpperCase() === 'COMPLETED') {
      const v = typeof ls.postureScore === 'number' ? ls.postureScore : ls.score;
      if (typeof v === 'number') allScores.push(v);
    }
  });
  surfaces.forEach(s => {
    const sc = webScanOf(s.target);
    if (sc && String(sc.status).toUpperCase() === 'COMPLETED' && typeof sc.score === 'number') allScores.push(sc.score);
  });
  const minScore = allScores.length ? Math.min(...allScores) : null;
  const avgScore = allScores.length ? Math.round(allScores.reduce((a, b) => a + b, 0) / allScores.length) : null;
  const srvConnected = srvList.filter(s => s.target).length;
  const srvLive = srvList.filter(s => s.lastScan && isLive(s.lastScan.status)).length;
  const srvAuto = srvList.filter(s => s.target && s.target.autoScan).length;
  const webInScanner = surfaces.filter(s => s.target).length;
  const webAuthorized = surfaces.filter(s => s.target && s.target.authorized).length;
  const webAuto = surfaces.filter(s => s.target && s.target.autoScan).length;
  const webLive = surfaces.filter(s => { const sc = webScanOf(s.target); return sc && isLive(sc.status); }).length;

  // Skanlar tarixi (server auditlari + web skanlar birga, vaqt bo'yicha)
  const historyRows = [
    ...srvList.flatMap(srv => (srv.history || []).map(h => ({
      id: 'srv:' + h.id, kind: 'server', name: srv.host, mode: h.mode, status: h.status,
      score: typeof h.postureScore === 'number' ? h.postureScore : h.score, findings: h.findingsCount, at: h.createdAt,
    }))),
    ...scans.map(x => {
      const tid = x.webTargetId || (x.webTarget && x.webTarget.id);
      const surf = surfaces.find(s => s.target && s.target.id === tid);
      return {
        id: 'web:' + x.id, kind: 'web', name: (surf && surf.url) || (x.webTarget && x.webTarget.baseUrl) || '—',
        mode: x.mode, status: x.status, score: x.score, findings: x._count ? x._count.findings : null, at: x.startedAt || x.createdAt,
      };
    }),
  ].sort((a, b) => new Date(b.at) - new Date(a.at)).slice(0, 12);

  // ── 🌐 Bitta manzil qatori (server kartasi / test-muhit / boshqa) ─────────
  const renderSurfaceRow = (s) => {
    const t = s.target;
    const scan = webScanOf(t);
    const live = scan && isLive(scan.status);
    return (
      <div key={s.key} className={`py-2 flex items-center gap-2 flex-wrap border-b border-gray-100 dark:border-gray-700 last:border-0 ${t ? '' : 'opacity-90'}`}>
        {!t && (
          <input type="checkbox" className="w-4 h-4 accent-primary-700 shrink-0" title="Skanerga qo'shish uchun tanlang"
            checked={picked.includes(s.key)} onChange={() => toggle(s.key)} />
        )}
        <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium shrink-0 ${s.kind === 'prod' ? 'bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-400' : 'bg-sky-50 dark:bg-sky-900/30 text-sky-700 dark:text-sky-400'}`}>
          {s.kind === 'prod' ? '🚀 prod' : '🧪 test'}
        </span>
        <div className="flex-1 min-w-[10rem]">
          <div className="text-xs font-medium text-gray-900 dark:text-white">{s.moduleName} <span className="text-gray-400 font-normal">{s.moduleType}</span></div>
          <a href={s.url} target="_blank" rel="noreferrer" className="text-[11px] text-gray-500 dark:text-gray-400 hover:text-primary-700 dark:hover:text-primary-300 break-all">{s.url}</a>
        </div>
        <div className="flex items-center gap-1.5 flex-wrap shrink-0">
          {!t && <span className="text-[11px] text-gray-400">skanerda yo'q</span>}
          {t && (<>
            {scan && (
              <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium ${SCAN_CLS[scan.status] || 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400'}`} title={scan.summary || ''}>
                {SCAN_LBL[scan.status] || scan.status}{typeof scan.score === 'number' ? ` · ${scan.score}` : ''}
              </span>
            )}
            {t.lastScanAt && <span className="text-[10px] text-gray-400">{fmtDate(t.lastScanAt)}</span>}
            <button onClick={() => setFlag(t, { authorized: !t.authorized })} disabled={busy === t.id}
              title={t.authorized ? 'Ruxsatni olib tashlash' : 'Skanlashga ruxsat berish (bu manzil sizniki ekaniga ishonch hosil qiling)'}
              className={`px-1.5 py-0.5 rounded text-[10px] font-medium border disabled:opacity-50 ${t.authorized
                ? 'bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400 border-emerald-200 dark:border-emerald-800'
                : 'bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400 border-gray-200 dark:border-gray-600'}`}>
              {t.authorized ? '🔓 ruxsat' : '🔒 ruxsat yo`q'}
            </button>
            <label className={`flex items-center gap-1 text-[10px] ${t.authorized ? 'text-gray-600 dark:text-gray-400' : 'text-gray-300 dark:text-gray-600'}`}
              title={t.authorized ? "Belgilangan oraliqda o'zi skan qiladi; yangi topilma chiqsa xabar keladi" : 'Avval ruxsat bering'}>
              <input type="checkbox" className="w-3 h-3 accent-primary-700" checked={!!t.autoScan}
                disabled={!t.authorized || busy === t.id} onChange={() => setFlag(t, { autoScan: !t.autoScan })} />⏱
            </label>
            {t.autoScan && (
              <select value={t.scanIntervalHours || 168} disabled={busy === t.id}
                onChange={(e) => setFlag(t, { scanIntervalHours: Number(e.target.value) })}
                className="text-[10px] border border-gray-200 dark:border-gray-700 rounded px-1 py-0.5 bg-white dark:bg-gray-800">
                {INTERVALS.map(i => <option key={i.h} value={i.h}>{i.t}</option>)}
              </select>
            )}
            <button onClick={() => startScan(t, 'PASSIVE')} disabled={busy === t.id || !t.authorized || live}
              title={t.authorized ? 'Passiv skan — payloadsiz, xavfsiz' : 'Avval ruxsat bering'}
              className="px-2 py-0.5 rounded text-[10px] font-medium bg-primary-700 dark:bg-primary-600 text-white hover:bg-primary-800 dark:hover:bg-primary-700 disabled:opacity-40">
              {busy === t.id ? '⏳' : live ? '⏳ ketmoqda' : '▶ Skan'}
            </button>
            {scan && String(scan.status).toUpperCase() === 'COMPLETED' && (
              <button onClick={() => loadFindings('web', scan.id)} title="Skan topilmalari"
                className={`px-2 py-0.5 rounded text-[10px] font-medium border ${findFor === `web:${scan.id}`
                  ? 'bg-primary-700 dark:bg-primary-600 text-white border-primary-700' : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700'}`}>
                📋 {scan._count && typeof scan._count.findings === 'number' ? scan._count.findings : 'Natija'}
              </button>
            )}
          </>)}
        </div>
      </div>
    );
  };

  // Karta ichida ochilgan web-skan natijasi (shu kartadagi manzillardan biri bo'lsa)
  const openWebFindingsFor = (list) => {
    if (!findFor || !findFor.startsWith('web:')) return null;
    const id = findFor.slice(4);
    const surf = list.find(s => scansOfTarget(s.target).some(x => x.id === id));
    if (!surf) return null;
    return (
      <div className="mt-3 pt-3 border-t border-gray-200 dark:border-gray-700">
        <div className="text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1">📋 Web skan natijasi — {surf.url}</div>
        <FindingsView data={findData} />
      </div>
    );
  };

  // ── 🔧 Tuzatish rejasi bloki (qadamlar) ───────────────────────────────────
  const renderSteps = () => (
    steps === null ? <div className="text-xs text-gray-400 mt-2">Yuklanmoqda…</div>
    : !steps.steps || !steps.steps.length ? (
      <div className="text-xs text-gray-400 mt-2">
        Qadam yo'q{String(steps.status).toUpperCase() !== 'COMPLETED' ? ' — skan hali tugamadi.' : ' — AI tuzatish rejasi tayyorlanmadi.'}
      </div>
    ) : (
      <div className="mt-2 space-y-2">
        {/* 🚀 Ommaviy tuzatish — har birini alohida bosish o'rniga */}
        <div className="rounded-lg bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-700 p-2.5 flex items-center gap-2 flex-wrap">
          <span className="text-[11px] font-medium text-gray-700 dark:text-gray-300">🚀 Hammasini tuzat:</span>
          <select value={fixRisk} onChange={e => setFixRisk(e.target.value)}
            disabled={!!(fixJob && fixJob.running)}
            className="text-xs border border-gray-200 dark:border-gray-700 rounded-lg px-1.5 py-1 bg-white dark:bg-gray-800">
            <option value="LOW">faqat past xavf</option>
            <option value="MEDIUM">past + oʻrta</option>
            <option value="HIGH">hammasi (yuqori ham)</option>
          </select>
          <button onClick={() => startFix(steps.id, steps.steps)}
            disabled={busy === 'fix' || !!(fixJob && fixJob.running)}
            title="Tanlangan darajagacha boʻlgan qadamlarni tasdiqlab, KETMA-KET bajaradi. Har qadamdan keyin ish tekshiriladi; buzilsa oʻsha qadam qaytariladi va jarayon toʻxtaydi."
            className="px-2.5 py-1 rounded-lg text-xs bg-teal-600 text-white hover:bg-teal-700 disabled:opacity-40">
            {fixJob && fixJob.running ? '⏳ Ketmoqda…' : '🚀 Boshlash'}
          </button>
          <span className="text-[10px] text-gray-500 dark:text-gray-400">
            {(steps.steps || []).filter(x => ['PROPOSED', 'APPROVED'].includes(String(x.status).toUpperCase())
              && (RANK[String(x.risk).toUpperCase()] || 3) <= (RANK[fixRisk] || 1)).length} ta mos qadam
          </span>
        </div>

        {/* Jarayon va natija */}
        {fixJob && fixJob.scanId === steps.id && (
          <div className={`rounded-lg border p-2.5 ${fixJob.stopped ? 'bg-red-50 dark:bg-red-900/30 border-red-200 dark:border-red-800' : fixJob.running ? 'bg-amber-50 dark:bg-amber-900/30 border-amber-200 dark:border-amber-800' : 'bg-emerald-50 dark:bg-emerald-900/30 border-emerald-200 dark:border-emerald-800'}`}>
            <div className="text-[11px] font-semibold text-gray-900 dark:text-white">
              {fixJob.running ? `⏳ ${fixJob.done}/${fixJob.total} — ${(fixJob.current && fixJob.current.title) || 'tayyorlanmoqda…'}`
                : fixJob.stopped ? `🛡️ Toʻxtatildi (${fixJob.ok}/${fixJob.total} bajarildi)`
                : `✅ Tugadi — ${fixJob.ok}/${fixJob.total} qadam bajarildi`}
            </div>
            {fixJob.reason && <div className="text-[11px] text-red-700 dark:text-red-400 mt-1">{fixJob.reason}</div>}
            {(fixJob.results || []).length > 0 && (
              <ul className="mt-1.5 space-y-0.5">
                {fixJob.results.map((x, i) => (
                  <li key={i} className="text-[11px] text-gray-700 dark:text-gray-300">
                    {x.ok ? '✅' : (x.rolledBack ? '↩' : '❌')} {x.title}
                    {x.broken && x.broken.length ? <span className="text-red-700 dark:text-red-400"> — buzildi: {x.broken.join(', ')}</span> : null}
                    {!x.ok && !x.broken && x.error ? <span className="text-gray-500 dark:text-gray-400"> — {String(x.error).slice(0, 90)}</span> : null}
                  </li>
                ))}
              </ul>
            )}
            {!fixJob.running && (
              <button onClick={() => setFixJob(null)} className="mt-1.5 text-[11px] text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white">✕ Yopish</button>
            )}
          </div>
        )}

        {steps.steps.map(st => {
          const sb = busy === 'step:' + st.id;
          const S = String(st.status).toUpperCase();
          return (
            <div key={st.id} className="rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700 p-2.5">
              <div className="flex items-start gap-2 flex-wrap">
                <span className={`px-1.5 py-0.5 rounded text-[10px] font-semibold ${STEP_CLS[S] || 'bg-gray-200 dark:bg-gray-600 text-gray-600 dark:text-gray-400'}`}>{STEP_LBL[S] || S}</span>
                <span className={`px-1.5 py-0.5 rounded text-[10px] font-semibold ${RISK_CLS[String(st.risk).toUpperCase()] || 'bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400'}`}>xavf: {String(st.risk || '—').toLowerCase()}</span>
                {st.requiresSudo && <span className="px-1.5 py-0.5 rounded text-[10px] bg-amber-100 dark:bg-amber-900/50 text-amber-700 dark:text-amber-400">sudo</span>}
                <span className="text-xs font-medium text-gray-900 dark:text-white">{st.title}</span>
              </div>
              {st.description && <p className="text-[11px] text-gray-600 dark:text-gray-400 mt-1">{st.description}</p>}
              <pre className="mt-1.5 text-[11px] bg-gray-900 text-gray-100 rounded-md p-2 overflow-x-auto whitespace-pre-wrap break-all">{st.command}</pre>
              {st.backupCmd && <div className="text-[10px] text-gray-500 dark:text-gray-400 mt-1">🗄 zaxira: <code className="break-all">{st.backupCmd}</code></div>}
              {st.rollbackCmd && <div className="text-[10px] text-gray-500 dark:text-gray-400">↩ qaytarish: <code className="break-all">{st.rollbackCmd}</code></div>}
              {st.output && <pre className="mt-1.5 text-[10px] bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded p-2 max-h-40 overflow-auto whitespace-pre-wrap">{st.output}</pre>}
              <div className="flex gap-1.5 mt-2 flex-wrap">
                <button onClick={() => explainStep(steps.id, st)} disabled={!!(stepInfo[st.id] && stepInfo[st.id].loading)}
                  title="Bu zaiflik nima va uni SHU loyiha uchun nega yopish kerak — oddiy tilda"
                  className="px-2 py-1 rounded-lg text-[11px] bg-sky-100 dark:bg-sky-900/50 text-sky-800 dark:text-sky-300 hover:bg-sky-200 dark:hover:bg-sky-800/70 disabled:opacity-50">
                  {stepInfo[st.id] && stepInfo[st.id].loading ? '⏳ Izoh…' : "ℹ️ Ma'lumot"}
                </button>
                {S === 'PROPOSED' && (<>
                  <button onClick={() => stepAction(steps.id, st, 'approve')} disabled={sb}
                    className="px-2 py-1 rounded-lg text-[11px] bg-emerald-600 text-white hover:bg-emerald-700 disabled:opacity-40">{sb ? '⏳' : '✅ Tasdiqlash'}</button>
                  <button onClick={() => stepAction(steps.id, st, 'reject')} disabled={sb}
                    className="px-2 py-1 rounded-lg text-[11px] bg-gray-200 dark:bg-gray-600 hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-40">⏭ Rad etish</button>
                </>)}
                {S === 'APPROVED' && (
                  <button onClick={() => stepAction(steps.id, st, 'execute')} disabled={sb}
                    title="Serverda bajariladi. Avval zaxira olinadi; bajarilgach ish tekshiriladi va buzilgan bo'lsa O'ZI orqaga qaytariladi."
                    className="px-2 py-1 rounded-lg text-[11px] bg-red-600 text-white hover:bg-red-700 disabled:opacity-40">{sb ? '⏳ Bajarilmoqda…' : '▶ Bajarish'}</button>
                )}
                {S === 'DONE' && st.rollbackCmd && (
                  <button onClick={() => stepAction(steps.id, st, 'rollback')} disabled={sb}
                    className="px-2 py-1 rounded-lg text-[11px] bg-gray-200 dark:bg-gray-600 hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-40">{sb ? '⏳' : '↩ Orqaga qaytarish'}</button>
                )}
              </div>
              {/* ℹ️ Izoh paneli — 5 bo'lim: nima / shu loyiha uchun xavf / tuzatish nima qiladi / xavflimi / shoshilinchmi */}
              {stepInfo[st.id] && stepInfo[st.id].open && (stepInfo[st.id].text || stepInfo[st.id].error || stepInfo[st.id].loading) && (
                <div className="mt-2 rounded-lg border border-sky-200 dark:border-sky-800 bg-sky-50 dark:bg-sky-900/30 p-2.5">
                  {stepInfo[st.id].error && <div className="text-[11px] text-red-700 dark:text-red-400">❌ {stepInfo[st.id].error}</div>}
                  {stepInfo[st.id].loading && !stepInfo[st.id].text && <div className="text-[11px] text-gray-500 dark:text-gray-400">⏳ Shu loyiha uchun izoh tayyorlanmoqda…</div>}
                  {stepInfo[st.id].text && (
                    <div className="text-[12px] text-gray-900 dark:text-white whitespace-pre-wrap leading-relaxed">{stepInfo[st.id].text}</div>
                  )}
                  <div className="mt-1.5 flex items-center gap-3">
                    <button onClick={() => setStepInfo(m => ({ ...m, [st.id]: { ...m[st.id], open: false } }))}
                      className="text-[11px] text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white">✕ Yopish</button>
                    <button onClick={() => explainStep(steps.id, st, true)} disabled={!!stepInfo[st.id].loading}
                      title="Izohni qaytadan yozdirish (token sarflaydi)"
                      className="text-[11px] text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 disabled:opacity-50">↻ qayta</button>
                  </div>
                </div>
              )}
            </div>
          );
        })}
        <p className="text-[11px] text-gray-400">
          Qadamlar o'z-o'zidan bajarilmaydi — avval ✅ tasdiqlaysiz, keyin ▶ bajarasiz. Bajarishdan oldin zaxira olinadi;
          bajarilgach ish tekshiriladi (SSH, sayt, pm2) va buzilgan bo'lsa 🛡️ o'zi orqaga qaytariladi.
        </p>
      </div>
    )
  );

  // Qadamlar holati bo'yicha qisqa hisob (reja ochiq bo'lsa)
  const stepStats = (list) => {
    const c = { total: list.length, PROPOSED: 0, APPROVED: 0, DONE: 0, FAILED: 0, REJECTED: 0, ROLLED_BACK: 0, RUNNING: 0 };
    list.forEach(x => { const S = String(x.status).toUpperCase(); if (c[S] !== undefined) c[S]++; });
    return c;
  };

  // ── 🖥 SERVER KARTASI — server va unga tegishli hamma narsa bitta joyda ────
  const renderServerCard = (srv) => {
    const t = srv.target, sc = srv.lastScan, rem = srv.lastRemediation;
    const b = busy === 'srv:' + srv.host;
    const live = sc && isLive(sc.status);
    const posture = sc && String(sc.status).toUpperCase() === 'COMPLETED'
      ? (typeof sc.postureScore === 'number' ? sc.postureScore : sc.score) : null;
    const tone = scoreTone(posture);
    const mySurfaces = surfacesOf(srv);
    const findOpen = sc && findFor === `server:${sc.id}`;
    const stepsOpen = rem && stepsFor === rem.id;
    const st = stepsOpen && steps && Array.isArray(steps.steps) ? stepStats(steps.steps) : null;
    return (
      <div key={srv.key} className={`bg-white dark:bg-gray-800 rounded-lg border shadow-sm ${srv.locked ? 'border-dashed border-amber-200 dark:border-amber-800' : 'border-gray-200 dark:border-gray-700'}`}>
        {/* Sarlavha qatori */}
        <div className="px-4 sm:px-5 py-3.5 border-b border-gray-100 dark:border-gray-700 flex items-center gap-3 flex-wrap">
          <div className="w-10 h-10 rounded-lg bg-gray-100 dark:bg-gray-700 flex items-center justify-center text-xl shrink-0">🖥</div>
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2 flex-wrap">
              <span className="text-base font-semibold text-gray-900 dark:text-white">{srv.host}</span>
              <span className="text-xs text-gray-400">{srv.username}</span>
              {srv.adminOnly && (
                <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-amber-100 dark:bg-amber-900/50 text-amber-800 dark:text-amber-300 border border-amber-200 dark:border-amber-800"
                  title="Bu Khorezmai platformasining yoki operatorning shaxsiy serveri — audit va tuzatish faqat admin hisobidan boshqariladi">🏛 platforma serveri</span>
              )}
              {sc && (
                <span className={`px-2 py-0.5 rounded text-[10px] font-medium ${SCAN_CLS[sc.status] || 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400'}`}>
                  {live ? '⏳ ' : ''}{SCAN_LBL[sc.status] || sc.status}{sc.createdAt ? ` · ${fmtDate(sc.createdAt)}` : ''}
                </span>
              )}
            </div>
            <div className="flex items-center gap-1 flex-wrap mt-1">
              <span className="text-[11px] text-gray-500 dark:text-gray-400">modullar:</span>
              {(srv.modules || []).map(m => <span key={m} className="px-1.5 py-0.5 rounded text-[10px] bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300">{m}</span>)}
            </div>
          </div>
          {/* Amallar */}
          <div className="flex items-center gap-2 flex-wrap shrink-0">
            {srv.locked && (
              <span className="px-2.5 py-1 rounded-lg text-xs bg-white dark:bg-gray-800 text-gray-500 dark:text-gray-400 border border-gray-200 dark:border-gray-700"
                title="Platforma serverining auditi, topilmalari va tuzatish qadamlari faqat admin hisobiga ochiq. Admin hisobi bilan kiring.">
                🔒 Faqat admin hisobidan boshqariladi
              </span>
            )}
            {!srv.locked && !t && (
              <button onClick={() => enableServer(srv)} disabled={b}
                className="px-3 py-1.5 rounded-lg text-xs font-medium bg-primary-700 dark:bg-primary-600 text-white hover:bg-primary-800 dark:hover:bg-primary-700 disabled:opacity-50">
                {b ? '⏳ Ulanmoqda…' : '🔐 SSH auditni yoqish'}
              </button>
            )}
            {t && (<>
              <label className="flex items-center gap-1 text-xs text-gray-600 dark:text-gray-400"
                title="Belgilangan oraliqda o'zi audit qiladi; yangi topilma chiqsa xabar keladi">
                <input type="checkbox" className="w-3.5 h-3.5 accent-primary-700" checked={!!t.autoScan} disabled={b}
                  onChange={() => setServerFlag(srv, { autoScan: !t.autoScan })} />⏱ avto
              </label>
              {t.autoScan && (
                <select value={t.scanIntervalHours || 24} disabled={b}
                  onChange={(e) => setServerFlag(srv, { scanIntervalHours: Number(e.target.value) })}
                  className="text-xs border border-gray-200 dark:border-gray-700 rounded-lg px-1.5 py-1 bg-white dark:bg-gray-800">
                  {INTERVALS.map(i => <option key={i.h} value={i.h}>{i.t}</option>)}
                </select>
              )}
              <button onClick={() => serverAudit(srv)} disabled={b || live}
                className="px-3 py-1.5 rounded-lg text-xs font-medium bg-primary-700 dark:bg-primary-600 text-white hover:bg-primary-800 dark:hover:bg-primary-700 disabled:opacity-40">
                {b ? '⏳' : live ? '⏳ Audit ketmoqda' : '▶ Audit'}
              </button>
              <button onClick={() => serverAudit(srv, 'REMEDIATION')} disabled={b || live}
                title="Audit qiladi VA har topilma uchun tuzatish qadamini tayyorlaydi (buyruq + zaxira + orqaga qaytarish). Hech narsa o'z-o'zidan bajarilmaydi."
                className="px-3 py-1.5 rounded-lg text-xs font-medium bg-teal-600 text-white hover:bg-teal-700 disabled:opacity-40">
                {b ? '⏳' : '🔧 Tuzatish rejasi'}
              </button>
            </>)}
          </div>
        </div>

        {/* Tana: 3 ustun — Ball | Manzillar | Topilma & Tuzatish */}
        <div className="p-4 sm:p-5">
          {srv.locked ? (
            <div className="text-sm text-gray-500 dark:text-gray-400">Bu server platformaga tegishli — ball, topilmalar va tuzatish rejasi admin hisobidan ko'rinadi.</div>
          ) : !t ? (
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
              <div className="lg:col-span-5 text-sm text-gray-500 dark:text-gray-400">
                SSH auditi hali yoqilmagan. Yoqilsa skaner serverga kirib firewall, portlar, SSH sozlamalari, Docker, sirlar va loglarni tekshiradi.
              </div>
              <div className="lg:col-span-7">
                <Tile title={`🌐 Manzillar (${mySurfaces.length})`}>
                  {mySurfaces.length ? mySurfaces.map(renderSurfaceRow) : <div className="text-xs text-gray-400">Bu serverdagi modullarda production manzil yo'q.</div>}
                </Tile>
              </div>
            </div>
          ) : (
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
              {/* Ball */}
              <div className="lg:col-span-3">
                <Tile title="🛡️ Xavfsizlik bali" className="h-full">
                  <div className="flex items-end justify-between gap-2">
                    <div>
                      <div className={`text-4xl font-bold leading-none ${SCORE_TXT[tone]}`}>{posture === null ? (live ? '…' : '—') : posture}<span className="text-base font-medium text-gray-400">/100</span></div>
                      {typeof (sc && sc.coverageConfidence) === 'number' && (
                        <div className="text-[11px] text-gray-500 dark:text-gray-400 mt-1" title="Qamrov ishonchi — hujum yuzasining qancha qismi ROSTDAN tekshirildi (asbob yetishmasa pasayadi)">
                          qamrov {sc.coverageConfidence}%
                        </div>
                      )}
                    </div>
                    <div className="w-24 sm:w-28"><MiniBars items={srv.history || []} height={44} /></div>
                  </div>
                  {live && <LiveProgress p={sc.progress} />}
                  <DiffChips d={sc && sc.diff} />
                  {sc && sc.summary && !live && (
                    <p className="text-[11px] text-gray-500 dark:text-gray-400 mt-2 line-clamp-3" title={sc.summary}>{sc.summary}</p>
                  )}
                  {!sc && <div className="text-[11px] text-gray-400 mt-2">Hali audit qilinmagan — ▶ Audit bosing.</div>}
                </Tile>
              </div>
              {/* Manzillar */}
              <div className="lg:col-span-5">
                <Tile title={`🌐 Manzillar (${mySurfaces.length})`} className="h-full"
                  right={<span className="text-[10px] text-gray-400">web skan — tashqaridan</span>}>
                  {mySurfaces.length ? mySurfaces.map(renderSurfaceRow) : <div className="text-xs text-gray-400">Bu serverdagi modullarda production manzil yo'q.</div>}
                </Tile>
              </div>
              {/* Topilma + tuzatish */}
              <div className="lg:col-span-4">
                <Tile title="🐞 Topilmalar va tuzatish" className="h-full">
                  <div className="grid grid-cols-2 gap-2">
                    <button onClick={() => sc && String(sc.status).toUpperCase() === 'COMPLETED' && loadFindings('server', sc.id)}
                      disabled={!sc || String(sc.status).toUpperCase() !== 'COMPLETED'}
                      title="Audit topilmalarini shu yerda ochish"
                      className={`text-left rounded-lg border p-2.5 transition disabled:opacity-50 ${findOpen
                        ? 'border-primary-300 dark:border-primary-700 bg-primary-50 dark:bg-primary-900/30' : 'border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700'}`}>
                      <div className="text-[10px] uppercase tracking-wide text-gray-500 dark:text-gray-400">audit topilmalari</div>
                      <div className="text-xl font-bold text-gray-900 dark:text-white leading-tight">{sc && typeof sc.findingsCount === 'number' ? sc.findingsCount : '—'}</div>
                      <div className="text-[10px] text-primary-700 dark:text-primary-400 mt-0.5">{findOpen ? '▲ yopish' : '📋 ochish'}</div>
                    </button>
                    <button onClick={() => rem && (stepsOpen ? (setStepsFor(null), setSteps(null)) : loadSteps(rem.id))}
                      disabled={!rem}
                      title={rem ? 'Tuzatish rejasi — buyruqlar ko`rinadi, bajarishni SIZ bosasiz' : '🔧 Tuzatish rejasi tugmasi bilan reja tayyorlang'}
                      className={`text-left rounded-lg border p-2.5 transition disabled:opacity-50 ${stepsOpen
                        ? 'border-teal-300 dark:border-teal-700 bg-teal-50 dark:bg-teal-900/30' : 'border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700'}`}>
                      <div className="text-[10px] uppercase tracking-wide text-gray-500 dark:text-gray-400">tuzatish qadamlari</div>
                      <div className="text-xl font-bold text-gray-900 dark:text-white leading-tight">{rem ? (rem.stepsCount || 0) : '—'}</div>
                      <div className="text-[10px] text-teal-700 dark:text-teal-400 mt-0.5">
                        {!rem ? 'reja yo`q' : stepsOpen ? '▲ yopish' : `🔧 ${SCAN_LBL[rem.status] || rem.status} · ${fmtDate(rem.createdAt)}`}
                      </div>
                    </button>
                  </div>
                  {st && (
                    <div className="flex flex-wrap gap-1 mt-2">
                      {st.DONE > 0 && <span className={`px-1.5 py-0.5 rounded text-[10px] ${STEP_CLS.DONE}`}>✅ {st.DONE} bajarildi</span>}
                      {st.APPROVED > 0 && <span className={`px-1.5 py-0.5 rounded text-[10px] ${STEP_CLS.APPROVED}`}>{st.APPROVED} tasdiqlangan</span>}
                      {st.PROPOSED > 0 && <span className={`px-1.5 py-0.5 rounded text-[10px] ${STEP_CLS.PROPOSED}`}>{st.PROPOSED} taklif</span>}
                      {st.FAILED > 0 && <span className={`px-1.5 py-0.5 rounded text-[10px] ${STEP_CLS.FAILED}`}>{st.FAILED} xato</span>}
                      {st.ROLLED_BACK > 0 && <span className={`px-1.5 py-0.5 rounded text-[10px] ${STEP_CLS.ROLLED_BACK}`}>{st.ROLLED_BACK} qaytarildi</span>}
                    </div>
                  )}
                  {findings && (
                    <div className="text-[11px] text-gray-500 dark:text-gray-400 mt-2">
                      🐞 Topilmalar bo'limida: loyiha bo'yicha {findings.total} ta{findings.new ? `, ${findings.new} ko'rilmagan` : ''}
                    </div>
                  )}
                </Tile>
              </div>
            </div>
          )}

          {/* Ochilgan bo'limlar — karta ostida to'liq kenglikda */}
          {findOpen && (
            <div className="mt-3 pt-3 border-t border-gray-200 dark:border-gray-700">
              <div className="text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1">📋 Audit natijasi · {fmtDate(sc.createdAt)}</div>
              <FindingsView data={findData} />
            </div>
          )}
          {stepsOpen && (
            <div className="mt-3 pt-3 border-t border-gray-200 dark:border-gray-700">
              <div className="text-xs font-semibold text-teal-700 dark:text-teal-400">🔧 Tuzatish rejasi · {SCAN_LBL[rem.status] || rem.status} · {fmtDate(rem.createdAt)}</div>
              {renderSteps()}
            </div>
          )}
          {openWebFindingsFor(mySurfaces)}
        </div>
      </div>
    );
  };

  // Manzillar guruhi kartasi (test muhiti / serverga bog'lanmagan prod manzillar)
  const renderSurfaceGroup = (key, title, hint, list) => (
    <div key={key} className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm">
      <div className="px-4 sm:px-5 py-3.5 border-b border-gray-100 dark:border-gray-700 flex items-center gap-3 flex-wrap">
        <div className="w-10 h-10 rounded-lg bg-gray-100 dark:bg-gray-700 flex items-center justify-center text-xl shrink-0">{key === 'test' ? '🧪' : '🌐'}</div>
        <div className="min-w-0 flex-1">
          <div className="text-base font-semibold text-gray-900 dark:text-white">{title}</div>
          <div className="text-[11px] text-gray-500 dark:text-gray-400">{hint}</div>
        </div>
        <span className="text-xs text-gray-400">{list.filter(s => s.target).length}/{list.length} skanerda</span>
      </div>
      <div className="px-4 sm:px-5 py-2">
        {list.map(renderSurfaceRow)}
        {openWebFindingsFor(list)}
      </div>
    </div>
  );

  return (
    <div className="p-4 sm:p-5 space-y-4">
      {toast && <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50 px-4 py-2 rounded-lg bg-gray-900 text-white text-sm shadow-lg">{toast}</div>}

      {/* Sarlavha */}
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white sm:text-2xl">🛡️ Xavfsizlik</h2>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-0.5 max-w-2xl">
            Har server o'z kartasida: SSH auditi bali, unga tegishli manzillar (web skan), topilmalar va tuzatish rejasi.
            Skanni siz boshlaysiz yoki <b>⏱ avto</b> qilib qo'yasiz — yangi topilma chiqsa telefoningizga xabar keladi.
          </p>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          {status && (
            <span className={`px-2.5 py-1 rounded-lg text-xs font-medium ${status.ok ? 'bg-emerald-100 dark:bg-emerald-900/50 text-emerald-700 dark:text-emerald-400' : 'bg-red-100 dark:bg-red-900/50 text-red-700 dark:text-red-400'}`}>
              {status.ok ? `✅ skaner ulangan · ${status.targets} nishon` : `❌ ${status.error || 'javob bermayapti'}`}
            </span>
          )}
          {findings && (
            <button onClick={importFindings} disabled={busy === 'import'}
              title="Tugagan skanlar natijasini 🐞 Topilmalar bo'limiga ko'chiradi (takrorlar qo'shilmaydi)"
              className="px-3 py-1.5 rounded-lg text-sm bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300 disabled:opacity-50">
              {busy === 'import' ? '⏳ Ko`chirilmoqda…' : '🐞 Topilmalarni yangilash'}
            </button>
          )}
          <button onClick={() => load()} disabled={loading}
            className="px-3 py-1.5 rounded-lg text-sm bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300 disabled:opacity-50">
            {loading ? '⏳' : '↻'} Yangilash
          </button>
        </div>
      </div>

      {err && <div className="rounded-lg border border-red-200 dark:border-red-800 bg-red-50 dark:bg-red-900/30 px-4 py-2.5 text-sm text-red-700 dark:text-red-400">{err}</div>}

      {/* 📊 Ko'rsatkichlar */}
      <div className="grid grid-cols-2 xl:grid-cols-4 gap-4">
        <StatCard icon="🛡️" label="Xavfsizlik bali (eng past)" tone={scoreTone(minScore)}
          value={minScore === null ? '—' : <>{minScore}<span className="text-base font-medium text-gray-400">/100</span></>}
          sub={allScores.length ? `${allScores.length} ta baholangan nishon${avgScore !== null && allScores.length > 1 ? ` · o'rtacha ${avgScore}` : ''}` : 'Hali tugagan skan yo`q'}
          title="Barcha nishonlar ichida eng past ball — zaif bo'g'in" />
        <StatCard icon="🖥" label="Serverlar (SSH auditi)" value={srvList.length}
          sub={srvList.length ? `${srvConnected} ulangan${srvLive ? ` · ⏳ ${srvLive} auditda` : ''}${srvAuto ? ` · ⏱ ${srvAuto} avto` : ''}` : 'modullarda prod server ko`rsatilmagan'} />
        <StatCard icon="🌐" label="Web manzillar" value={surfaces.length}
          sub={surfaces.length ? `${webInScanner} skanerda · 🔓 ${webAuthorized} ruxsat${webAuto ? ` · ⏱ ${webAuto} avto` : ''}${webLive ? ` · ⏳ ${webLive} skanda` : ''}` : 'prod/test manzil yo`q'} />
        <StatCard icon="🐞" label="Xavfsizlik topilmalari" value={findings ? findings.total : '—'}
          tone={findings && findings.high ? 'bad' : findings && findings.new ? 'mid' : 'none'}
          sub={!findings ? 'yuklanmoqda…' : findings.total === 0 ? 'Hali topilma yo`q — skan tugagach chiqadi'
            : `${findings.new} ko'rilmagan${findings.high ? ` · ${findings.high} jiddiy` : ''} — 🐞 Topilmalar bo'limida vazifaga aylanadi`} />
      </div>

      {/* Qo'shish paneli */}
      {newOnes.length > 0 && (
        <div className="rounded-lg border border-primary-200 dark:border-primary-800 bg-primary-50 dark:bg-primary-900/30 p-4">
          <div className="flex items-center justify-between gap-3 flex-wrap">
            <div className="text-sm text-primary-900 dark:text-primary-200">
              <b>{newOnes.length} ta manzil</b> hali skanerga berilmagan — kartalardagi ☐ bilan tanlang.
            </div>
            <div className="flex items-center gap-2">
              <button onClick={() => setPicked(newOnes.map(s => s.key))}
                className="px-2.5 py-1 rounded-lg text-xs bg-white dark:bg-gray-800 hover:bg-primary-100 dark:hover:bg-primary-900/60 text-primary-800 dark:text-primary-300 border border-primary-200 dark:border-primary-800">Hammasi</button>
              <button onClick={addTargets} disabled={!picked.length || busy === 'sync'}
                className="px-3.5 py-1.5 rounded-lg text-sm font-medium bg-primary-700 dark:bg-primary-600 text-white hover:bg-primary-800 dark:hover:bg-primary-700 disabled:opacity-40">
                {busy === 'sync' ? '⏳ Qo`shilmoqda…' : `➕ Skanerga qo'shish (${picked.length})`}
              </button>
            </div>
          </div>
          <div className="text-xs text-primary-800/80 dark:text-primary-300/80 mt-2">
            Nishon <b>ruxsatsiz</b> qo'shiladi — skan boshlanmaydi. Ruxsatni har bir manzil uchun alohida yoqasiz.
          </div>
        </div>
      )}

      {/* 🖥 Server kartalari */}
      {srvList.map(renderServerCard)}
      {!srvList.length && !loading && servers !== null && (
        <div className="rounded-lg border border-dashed border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700 p-5 text-sm text-gray-500 dark:text-gray-400">
          Bu loyihada production server ko'rsatilmagan (modul sozlamalarida «Prod Host»). Server ko'rsatilsa u shu yerda o'z kartasi bilan chiqadi.
        </div>
      )}

      {/* 🧪 Test muhiti + serverga bog'lanmagan prod manzillar */}
      {testSurfaces.length > 0 && renderSurfaceGroup('test', 'Test muhiti', 'Khorezmai serveridagi test manzillar — web skan (SSH auditi platforma serveriga tegishli)', testSurfaces)}
      {otherSurfaces.length > 0 && renderSurfaceGroup('other', 'Boshqa manzillar', 'Production manzili bor, lekin serveri ko`rsatilmagan modullar', otherSurfaces)}
      {surfaces.length === 0 && !srvList.length && !loading && (
        <div className="rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700 p-5 text-sm text-gray-500 dark:text-gray-400">
          Bu loyihada skan qilinadigan manzil topilmadi — modullarga <b>production</b> yoki <b>test</b> manzili qo'yilmagan.
        </div>
      )}

      {/* 📜 Skanlar tarixi — jadval */}
      {historyRows.length > 0 && (
        <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm">
          <div className="px-4 sm:px-5 py-3.5 border-b border-gray-100 dark:border-gray-700 flex items-center justify-between">
            <div>
              <div className="text-base font-semibold text-gray-900 dark:text-white">Oxirgi skanlar</div>
              <div className="text-[11px] text-gray-500 dark:text-gray-400">server auditlari va web skanlar birga — to'liq topilmalar kartadagi 📋 tugmasida</div>
            </div>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full text-sm text-left">
              <thead className="text-[11px] uppercase text-gray-500 dark:text-gray-400 bg-gray-50 dark:bg-gray-700/60">
                <tr>
                  <th className="px-4 sm:px-5 py-2.5 font-medium">Nishon</th>
                  <th className="px-3 py-2.5 font-medium">Rejim</th>
                  <th className="px-3 py-2.5 font-medium">Holat</th>
                  <th className="px-3 py-2.5 font-medium text-right">Ball</th>
                  <th className="px-3 py-2.5 font-medium text-right">Topilma</th>
                  <th className="px-4 sm:px-5 py-2.5 font-medium text-right">Vaqt</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100 dark:divide-gray-700">
                {historyRows.map(r => (
                  <tr key={r.id} className="hover:bg-gray-50 dark:hover:bg-gray-700/40">
                    <td className="px-4 sm:px-5 py-2 text-gray-900 dark:text-white">
                      <span className="mr-1.5">{r.kind === 'server' ? '🖥' : '🌐'}</span>
                      <span className="text-xs break-all">{r.name}</span>
                    </td>
                    <td className="px-3 py-2 text-xs text-gray-500 dark:text-gray-400">{String(r.mode || '').toLowerCase()}</td>
                    <td className="px-3 py-2"><span className={`px-2 py-0.5 rounded text-[10px] font-medium ${SCAN_CLS[r.status] || 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400'}`}>{SCAN_LBL[r.status] || r.status}</span></td>
                    <td className={`px-3 py-2 text-right text-xs font-semibold ${SCORE_TXT[scoreTone(typeof r.score === 'number' ? r.score : undefined)]}`}>{typeof r.score === 'number' ? r.score : '—'}</td>
                    <td className="px-3 py-2 text-right text-xs text-gray-700 dark:text-gray-300">{typeof r.findings === 'number' ? r.findings : '—'}</td>
                    <td className="px-4 sm:px-5 py-2 text-right text-xs text-gray-400 whitespace-nowrap">{fmtDate(r.at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
